module.exports = __webpack_public_path__ + "files/a65af8d4c05e4220cd132d49bd4c4cd1.png";